import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ToPeppolSubmissionQueueContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_to_peppol_submission_queue_container.model';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({
  providedIn: 'root'
})

export class ToPeppolSubmissionQueueService extends BaseApiPublicLoginTemplateService<ToPeppolSubmissionQueueContainerModel, ToPeppolSubmissionQueueContainerModel, ToPeppolSubmissionQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'peppol/to-peppol-submission-queues/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'peppol/to-peppol-submission-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'peppol/to-peppol-submission-queues/backoffice-ep'
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'peppol/to-peppol-submission-queues/' + BaseApiTemplateService.LOGIN_EP
    this.httpClient = http;
  }

}
